import React from 'react'

export default function RightCol({ title, children }: { title?: string; children: React.ReactNode }) {
    return (
        <div className="bg-gray-accent-light bg-opacity-10 md:p-6">
            {title && <h2 className="m-0 mb-2 pl-3 text-[18px] font-bold text-black/70">{title}</h2>}
            <div className="h-full md:max-w-[350px]">{children}</div>
        </div>
    )
}
